import { render, staticRenderFns } from "./uiPreim.vue?vue&type=template&id=25789190&scoped=true"
import script from "./uiPreim.vue?vue&type=script&lang=js"
export * from "./uiPreim.vue?vue&type=script&lang=js"
import style0 from "./uiPreim.vue?vue&type=style&index=0&id=25789190&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25789190",
  null
  
)

export default component.exports